(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    var page = document.querySelector('.bg-post-page');
    if (!page) return;
    var progressBar = document.querySelector('[data-post-progress-bar]');
    var copyBtn = page.querySelector('[data-post-copy]');
    var copyLabel = copyBtn ? copyBtn.querySelector('[data-post-copy-label]') : null;
    var totop = document.querySelector('[data-post-totop]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var raf = null;
    var onScroll = function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var doc = document.documentElement;
        var max = doc.scrollHeight - window.innerHeight;
        var pct = max > 0 ? Math.min(100, Math.max(0, (window.scrollY / max) * 100)) : 0;
        if (progressBar) progressBar.style.width = pct + '%';
        if (totop) totop.classList.toggle('is-visible', pct > 4);
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url = copyBtn.getAttribute('data-copy-url') || window.location.href;
        var done = function () {
          if (!copyLabel) return;
          var original = copyLabel.textContent;
          copyLabel.textContent = copyBtn.getAttribute('data-copied-label') || original;
          setTimeout(function () { copyLabel.textContent = original; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, function () {});
        }
      });
    }

    if (totop) {
      totop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (function () {
    var blog = document.querySelector('[data-blog]');
    if (!blog) return;
    var grid = blog.querySelector('[data-blog-grid]');
    var items = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-blog-item]')) : [];
    if (!items.length) return;

    var chipsWrap = blog.querySelector('[data-blog-chips]');
    var chips = blog.querySelectorAll('[data-blog-chips] [data-topic]');
    var searchInput = blog.querySelector('[data-blog-search]');
    var searchBtn = blog.querySelector('[data-blog-search-btn]');
    var sortBtn = blog.querySelector('[data-blog-sort]');
    var resultLabel = blog.querySelector('[data-blog-resultlabel]');
    var resetBtn = blog.querySelector('[data-blog-reset]');
    var emptyEl = blog.querySelector('[data-blog-empty]');
    var emptyResetBtn = blog.querySelector('[data-blog-reset-btn]');
    var moreWrap = blog.querySelector('[data-blog-more]');
    var moreBtn = blog.querySelector('[data-blog-morebtn]');
    var progressEl = blog.querySelector('[data-blog-progress]');

    var norm = function (s) {
      return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    };

    var PAGE = 9;
    var state = { query: '', topic: '', sort: 'recent', visibleCount: PAGE };
    var qs = new URLSearchParams(window.location.search);
    if (qs.get('tag')) state.topic = qs.get('tag');
    if (searchInput && qs.get('q')) state.query = qs.get('q');
    if (searchInput) searchInput.value = state.query;

    var setActiveChip = function () {
      chips.forEach(function (c) {
        var on = c.dataset.topic === state.topic;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };

    var applySort = function () {
      var sorted = items.slice().sort(function (a, b) {
        var ra = parseInt(a.dataset.rank, 10), rb = parseInt(b.dataset.rank, 10);
        return state.sort === 'recent' ? ra - rb : rb - ra;
      });
      sorted.forEach(function (el) { grid.appendChild(el); });
      return sorted;
    };

    var isFiltered = function () { return !!(state.query || state.topic); };

    var render = function () {
      var ordered = applySort();
      var q = norm(state.query);
      var matches = ordered.filter(function (el) {
        if (state.topic && (el.dataset.topics || '').split('|').indexOf(state.topic) === -1) return false;
        if (q && (norm(el.dataset.title) + ' ' + norm(el.dataset.topics)).indexOf(q) === -1) return false;
        return true;
      });
      ordered.forEach(function (el) { el.hidden = true; });
      matches.slice(0, state.visibleCount).forEach(function (el) { el.hidden = false; });

      var total = matches.length;
      if (resultLabel) {
        var d = resultLabel.dataset;
        var tpl = isFiltered() ? (total > 1 ? d.foundOther : d.foundOne) : (total > 1 ? d.other : d.one);
        resultLabel.textContent = (tpl || '__N__').replace('__N__', total);
      }
      if (resetBtn) resetBtn.hidden = !isFiltered();
      grid.hidden = total === 0;
      if (emptyEl) emptyEl.hidden = total !== 0;
      if (moreWrap) moreWrap.hidden = state.visibleCount >= total;
      if (progressEl) progressEl.textContent = (progressEl.dataset.template || '__S__ / __T__').replace('__S__', Math.min(state.visibleCount, total)).replace('__T__', total);
      if (sortBtn) {
        var lbl = sortBtn.querySelector('[data-blog-sortlabel]');
        if (lbl) lbl.textContent = state.sort === 'recent' ? lbl.dataset.recent : lbl.dataset.oldest;
      }
    };

    var syncUrl = function () {
      var params = new URLSearchParams();
      if (state.topic) params.set('tag', state.topic);
      if (state.query) params.set('q', state.query);
      var qstr = params.toString();
      window.history.replaceState(null, '', window.location.pathname + (qstr ? '?' + qstr : '') + window.location.hash);
    };

    if (chipsWrap) {
      chipsWrap.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-topic]');
        if (!chip) return;
        state.topic = chip.dataset.topic;
        state.visibleCount = PAGE;
        setActiveChip(); render(); syncUrl();
      });
    }
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        state.query = searchInput.value;
        state.visibleCount = PAGE;
        render(); syncUrl();
      });
    }
    if (searchBtn) searchBtn.addEventListener('click', function () { if (searchInput) searchInput.focus(); });
    if (sortBtn) sortBtn.addEventListener('click', function () { state.sort = state.sort === 'recent' ? 'old' : 'recent'; render(); });
    var resetAll = function () {
      state.query = ''; state.topic = ''; state.visibleCount = PAGE;
      if (searchInput) searchInput.value = '';
      setActiveChip(); render(); syncUrl();
    };
    if (resetBtn) resetBtn.addEventListener('click', resetAll);
    if (emptyResetBtn) emptyResetBtn.addEventListener('click', resetAll);
    if (moreBtn) moreBtn.addEventListener('click', function () { state.visibleCount += PAGE; render(); });

    setActiveChip();
    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-root]');
    if (!root) return;

    var sectionId = root.getAttribute('data-section-id');
    var chain = Promise.resolve();

    root.classList.add('gf-cart--js');

    function routeRoot() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
      return '/';
    }

    function keyOf(el) {
      var line = el.closest('[data-cart-line]');
      return line ? line.getAttribute('data-cart-key') : null;
    }

    function showError(lineEl, message) {
      var box = lineEl ? lineEl.querySelector('[data-cart-error]') : null;
      if (!box) return;
      box.textContent = message;
      box.hidden = false;
    }

    function clearError(lineEl) {
      var box = lineEl ? lineEl.querySelector('[data-cart-error]') : null;
      if (!box) return;
      box.hidden = true;
      box.textContent = '';
    }

    function swapInner(doc, selector) {
      var next = doc.querySelector(selector);
      var current = root.querySelector(selector);
      if (next && current) current.innerHTML = next.innerHTML;
      return { next: next, current: current };
    }

    function applyResponse(data) {
      var html = data.sections && data.sections[sectionId];
      if (!html) {
        window.location.reload();
        return;
      }
      if (data.item_count === 0) {
        window.location.reload();
        return;
      }

      var doc = new DOMParser().parseFromString(html, 'text/html');

      var lines = swapInner(doc, '[data-cart-lines]');
      if (lines.current) lines.current.classList.add('is-swapped');

      swapInner(doc, '[data-cart-rows]');
      swapInner(doc, '[data-cart-count]');

      var ship = swapInner(doc, '[data-cart-ship]');
      if (ship.next && ship.current) {
        ship.current.classList.toggle('is-unlocked', ship.next.classList.contains('is-unlocked'));
      }

      var badge = document.querySelector('.bg-cart-badge');
      if (badge) badge.textContent = data.item_count;
    }

    function change(key, quantity, lineEl) {
      if (lineEl) {
        lineEl.classList.add('is-busy');
        clearError(lineEl);
      }

      chain = chain.then(function () {
        return fetch(routeRoot() + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity: quantity,
            sections: sectionId,
            sections_url: window.location.pathname
          })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw new Error(data.description || data.message || '');
              return data;
            });
          })
          .then(applyResponse)
          .catch(function (err) {
            if (lineEl && lineEl.isConnected) {
              lineEl.classList.remove('is-busy');
              lineEl.classList.remove('is-leaving');
              showError(lineEl, err.message || 'Error');
            } else {
              window.location.reload();
            }
          });
      });

      return chain;
    }

    root.addEventListener('click', function (event) {
      var step = event.target.closest('[data-cart-step]');
      if (step) {
        var lineEl = step.closest('[data-cart-line]');
        var input = lineEl.querySelector('[data-cart-qty]');
        var delta = parseInt(step.getAttribute('data-cart-step'), 10);
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = next;
        change(keyOf(step), next, lineEl);
        return;
      }

      var remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        var removeLine = remove.closest('[data-cart-line]');
        removeLine.classList.add('is-leaving');
        var key = keyOf(remove);
        window.setTimeout(function () {
          change(key, 0, removeLine);
        }, 260);
      }
    });

    var typingTimer = null;
    root.addEventListener('input', function (event) {
      var input = event.target.closest('[data-cart-qty]');
      if (!input) return;
      window.clearTimeout(typingTimer);
      typingTimer = window.setTimeout(function () {
        var lineEl = input.closest('[data-cart-line]');
        var value = Math.max(0, parseInt(input.value, 10) || 0);
        change(keyOf(input), value, lineEl);
      }, 650);
    });

    function refreshShippingRate() {
      var ship = root.querySelector('[data-cart-ship]');
      var valueEl = root.querySelector('[data-cart-ship-value]');
      if (!ship || !valueEl) return;

      if (ship.classList.contains('is-unlocked')) return;

      var country = ship.getAttribute('data-rate-country');
      if (!country) return;
      var zip = ship.getAttribute('data-rate-zip') || '';

      var url = routeRoot() + 'cart/shipping_rates.json' +
        '?shipping_address[country]=' + encodeURIComponent(country) +
        '&shipping_address[zip]=' + encodeURIComponent(zip);

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('rates unavailable');
          return res.json();
        })
        .then(function (data) {
          var rates = data && data.shipping_rates;
          if (!rates || !rates.length) return;

          var cheapest = null;
          rates.forEach(function (rate) {
            var price = parseFloat(rate.price);
            if (isNaN(price)) return;
            if (cheapest === null || price < cheapest.value) {
              cheapest = { value: price, raw: rate.price };
            }
          });
          if (cheapest === null) return;

          if (cheapest.value === 0) {
            valueEl.textContent = ship.getAttribute('data-free-label') || '';
            ship.classList.add('is-unlocked');
            return;
          }

          var sample = ship.getAttribute('data-money-sample') || '0.00';
          var mp = sample.match(/^(.*?)([0-9][0-9.,'’   ]*[0-9]|[0-9])(.*)$/);
          var dec = mp && mp[2].length > 2 ? mp[2].charAt(mp[2].length - 3) : '.';
          var num = cheapest.value.toFixed(2).replace('.', dec);
          valueEl.textContent = mp ? mp[1] + num + mp[3] : num;
        })
        .catch(function () {

        });
    }

    refreshShippingRate();

    var promoStore = 'bg-cart-discount';
    var promoInput = root.querySelector('[data-cart-promo-input]');
    var promoNote = root.querySelector('[data-cart-promo-note]');

    function readPromo() {
      try { return window.sessionStorage.getItem(promoStore); } catch (err) { return null; }
    }

    function showPromo(code) {
      if (!promoNote) return;
      var template = promoNote.getAttribute('data-template') || '';
      promoNote.textContent = template.replace('__CODE__', code);
      promoNote.hidden = false;
    }

    function applyPromo() {
      if (!promoInput) return;
      var code = promoInput.value.trim();
      if (!code) return;
      try { window.sessionStorage.setItem(promoStore, code); } catch (err) {}

      window.location.href =
        routeRoot() + 'discount/' + encodeURIComponent(code) +
        '?redirect=' + encodeURIComponent(window.location.pathname);
    }

    if (promoInput) {
      var storedPromo = readPromo();
      if (storedPromo) {
        promoInput.value = storedPromo;
        showPromo(storedPromo);
      }
      promoInput.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        applyPromo();
      });
      promoInput.addEventListener('input', function () {
        if (promoInput.value.trim()) return;
        try { window.sessionStorage.removeItem(promoStore); } catch (err) {}
        if (promoNote) promoNote.hidden = true;
      });
    }

    var promoApply = root.querySelector('[data-cart-promo-apply]');
    if (promoApply) promoApply.addEventListener('click', applyPromo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var state = document.querySelector('[data-ct-state]');
    if (state && window.Intl && Intl.DateTimeFormat) {
      try {
        var parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Zurich', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
        }).formatToParts(new Date());
        var p = {};
        parts.forEach(function (x) { p[x.type] = x.value; });
        var mins = parseInt(p.hour, 10) * 60 + parseInt(p.minute, 10);
        var day = p.weekday;
        var morning = mins >= 480 && mins < 720;
        var afternoon = mins >= 810 && mins < 960;
        var isOpen = (['Mon', 'Tue', 'Wed', 'Thu'].indexOf(day) > -1 && (morning || afternoon)) || (day === 'Fri' && morning);
        state.textContent = isOpen ? state.getAttribute('data-open') : state.getAttribute('data-closed');
        state.classList.toggle('is-open', isOpen);
        state.hidden = false;
      } catch (e) { }
    }

    var success = document.querySelector('[data-ct-success]');
    if (success) {
      success.scrollIntoView({ block: 'center' });
      success.focus({ preventScroll: true });
    }

    var form = document.querySelector('.gf-ct-form');
    if (!form) return;
    var serverErrors = form.querySelector('[data-ct-errors]');
    if (serverErrors && !serverErrors.hidden) serverErrors.focus();

    form.setAttribute('novalidate', '');
    var fields = form.querySelectorAll('[required]');
    var emailRe = /^[^@ ]+@[^@ ]+[.][^@ ]+$/;

    function invalid(el) {
      var v = (el.value || '').trim();
      if (!v) return true;
      if (el.type === 'email' && !emailRe.test(v)) return true;
      return false;
    }
    function mark(el, bad) {
      var err = document.getElementById(el.id + '-err');
      if (bad) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
      if (err) err.hidden = !bad;
    }

    Array.prototype.forEach.call(fields, function (el) {
      el.addEventListener('blur', function () { if (el.value) mark(el, invalid(el)); });
      el.addEventListener('input', function () { if (el.getAttribute('aria-invalid')) mark(el, invalid(el)); });
    });

    form.addEventListener('submit', function (e) {
      var bad = [];
      Array.prototype.forEach.call(fields, function (el) {
        var b = invalid(el);
        mark(el, b);
        if (b) bad.push(el);
      });
      var box = form.querySelector('[data-ct-errors]');
      var list = form.querySelector('[data-ct-errors-list]');
      if (bad.length) {
        e.preventDefault();
        if (box && list) {
          list.innerHTML = '';
          bad.forEach(function (el) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.href = '#' + el.id;
            a.textContent = el.getAttribute('data-ct-msg') || '';
            li.appendChild(a);
            list.appendChild(li);
          });
          box.hidden = false;
        }
        bad[0].focus();
        return;
      }
      if (box) box.hidden = true;
      var btn = form.querySelector('[data-ct-submit]');
      if (btn) {
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = btn.getAttribute('data-sending') || btn.textContent;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["espace-pro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var success = document.querySelector('[data-rv-success]');
    if (success) {
      success.scrollIntoView({ block: 'center' });
      success.focus({ preventScroll: true });
    }
    var form = document.querySelector('.gf-rv-form');
    if (!form) return;
    var serverErrors = form.querySelector('[data-rv-errors]');
    if (serverErrors && !serverErrors.hidden) serverErrors.focus();

    form.setAttribute('novalidate', '');
    var fields = form.querySelectorAll('[required]');
    var emailRe = /^[^@ ]+@[^@ ]+[.][^@ ]+$/;
    function invalid(el) {
      var v = (el.value || '').trim();
      if (!v) return true;
      if (el.type === 'email' && !emailRe.test(v)) return true;
      return false;
    }
    function mark(el, bad) {
      var err = document.getElementById(el.id + '-err');
      if (bad) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid');
      if (err) err.hidden = !bad;
    }
    Array.prototype.forEach.call(fields, function (el) {
      el.addEventListener('blur', function () { if (el.value) mark(el, invalid(el)); });
      el.addEventListener('input', function () { if (el.getAttribute('aria-invalid')) mark(el, invalid(el)); });
      el.addEventListener('change', function () { if (el.getAttribute('aria-invalid')) mark(el, invalid(el)); });
    });
    form.addEventListener('submit', function (e) {
      var bad = [];
      Array.prototype.forEach.call(fields, function (el) {
        var b = invalid(el);
        mark(el, b);
        if (b) bad.push(el);
      });
      var box = form.querySelector('[data-rv-errors]');
      var list = form.querySelector('[data-rv-errors-list]');
      if (bad.length) {
        e.preventDefault();
        if (box && list) {
          list.innerHTML = '';
          bad.forEach(function (el) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.href = '#' + el.id;
            a.textContent = el.getAttribute('data-rv-msg') || '';
            li.appendChild(a);
            list.appendChild(li);
          });
          box.hidden = false;
        }
        bad[0].focus();
        return;
      }
      if (box) box.hidden = true;
      var btn = form.querySelector('[data-rv-submit]');
      if (btn) {
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = btn.getAttribute('data-sending') || btn.textContent;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var cols = document.querySelectorAll('[data-ft-acc]');
    if (!cols.length || !window.matchMedia) return;
    var narrow = window.matchMedia('(max-width: 900px)');
    function apply() {
      Array.prototype.forEach.call(cols, function (col) {
        var sum = col.querySelector('summary');
        if (narrow.matches) {
          col.open = false;
          if (sum) sum.removeAttribute('tabindex');
        } else {
          col.open = true;
          if (sum) sum.setAttribute('tabindex', '-1');
        }
      });
    }
    Array.prototype.forEach.call(cols, function (col) {
      var sum = col.querySelector('summary');
      if (sum) sum.addEventListener('click', function (e) { if (!narrow.matches) e.preventDefault(); });
    });
    apply();
    if (narrow.addEventListener) narrow.addEventListener('change', apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-body-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.gfBm) return;
      root.gfBm = true;

      var stage = root.querySelector('[data-bm-stage]');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bm-tab]'));
      if (!stage || !tabs.length) return;
      var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
      var spots = Array.prototype.slice.call(root.querySelectorAll('[data-bm-spot]'));
      var svg = root.querySelector('[data-bm-lines]');
      var halo = svg.querySelector('.gf-bm-halo');
      var leader = svg.querySelector('.gf-bm-leader');
      var end = svg.querySelector('.gf-bm-end');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var current = 0;
      var hoverTimer = null;

      tabs.forEach(function (t, i) { if (t.getAttribute('aria-selected') === 'true') current = i; });

      function draw(animate) {
        if (getComputedStyle(svg).display === 'none') return;
        var tab = tabs[current];
        var panel = panels[current];
        if (!tab || !panel || panel.hidden) { svg.classList.add('is-empty'); return; }
        var s = stage.getBoundingClientRect();
        var d = tab.querySelector('.gf-bm-dot').getBoundingClientRect();
        var p = panel.getBoundingClientRect();
        var photo = stage.querySelector('.gf-bm-photo').getBoundingClientRect();
        var mx = d.left + d.width / 2 - s.left;
        var my = d.top + d.height / 2 - s.top;
        var ex, ey;
        if (p.top >= photo.bottom - 2) {
          ex = Math.min(Math.max(mx, p.left - s.left + 40), p.right - s.left - 40);
          ey = p.top - s.top;
        } else {
          ex = p.left - s.left;
          ey = Math.min(Math.max(my, p.top - s.top + 56), p.bottom - s.top - 56);
        }
        var dpath = 'M' + mx.toFixed(1) + ' ' + my.toFixed(1) + ' L' + ex.toFixed(1) + ' ' + ey.toFixed(1);
        svg.setAttribute('viewBox', '0 0 ' + s.width.toFixed(1) + ' ' + s.height.toFixed(1));
        halo.setAttribute('d', dpath);
        leader.setAttribute('d', dpath);
        end.setAttribute('cx', ex.toFixed(1));
        end.setAttribute('cy', ey.toFixed(1));
        svg.classList.remove('is-empty');

        [halo, leader].forEach(function (el) {
          el.style.transition = 'none';
          el.style.strokeDasharray = '';
          el.style.strokeDashoffset = '';
        });
        end.style.transition = 'none';
        end.style.opacity = '1';
        if (animate && !reduce.matches) {
          var len = Math.hypot(ex - mx, ey - my);
          [halo, leader].forEach(function (el) {
            el.style.strokeDasharray = len + ' ' + len;
            el.style.strokeDashoffset = String(len);
          });
          end.style.opacity = '0';
          svg.getBoundingClientRect();
          [halo, leader].forEach(function (el) {
            el.style.transition = 'stroke-dashoffset 0.36s cubic-bezier(0.16, 1, 0.3, 1)';
            el.style.strokeDashoffset = '0';
          });
          end.style.transition = 'opacity 0.2s ease 0.24s';
          end.style.opacity = '1';
        }
      }

      function select(i, opts) {
        opts = opts || {};
        if (i < 0 || i >= tabs.length) return;
        var changed = i !== current;
        current = i;
        tabs.forEach(function (t, k) {
          var on = k === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (panels[k]) {
            panels[k].hidden = !on;
            panels[k].classList.remove('is-entering');
          }
          if (spots[k]) spots[k].classList.toggle('is-active', on);
        });
        if (changed && panels[i] && !reduce.matches) {
          void panels[i].offsetWidth;
          panels[i].classList.add('is-entering');
        }
        if (opts.focus) tabs[i].focus();
        if (opts.reveal && tabs[i].scrollIntoView && getComputedStyle(svg).display === 'none') {
          var row = tabs[i].parentElement;
          row.scrollTo({ left: tabs[i].offsetLeft - 16, behavior: reduce.matches ? 'auto' : 'smooth' });
        }
        draw(changed || opts.animate);
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i, { reveal: true }); });
        t.addEventListener('mouseenter', function () {
          if (getComputedStyle(svg).display === 'none') return;
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(function () { select(i); }, 140);
        });
        t.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); });
      });
      spots.forEach(function (s, i) {
        s.addEventListener('click', function () { select(i, { reveal: true }); });
      });

      root.querySelector('[data-bm-tablist]').addEventListener('keydown', function (e) {
        var n = tabs.length, to = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') to = (current + 1) % n;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') to = (current - 1 + n) % n;
        else if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = n - 1;
        if (to === null) return;
        e.preventDefault();
        select(to, { focus: true, reveal: true });
      });

      function indexForHash(hash) {
        var id = (hash || '').replace(/^#/, '');
        if (!id) return -1;
        for (var k = 0; k < tabs.length; k++) { if (tabs[k].id === id) return k; }
        return -1;
      }
      function goTo(i, smooth) {
        select(i, { reveal: true, animate: true });
        var behave = smooth && !reduce.matches ? 'smooth' : 'auto';
        requestAnimationFrame(function () { root.scrollIntoView({ block: 'start', behavior: behave }); });
      }

      window.addEventListener('hashchange', function () {
        var i = indexForHash(location.hash);
        if (i > -1) goTo(i, true);
      });
      document.addEventListener('click', function (e) {
        var a = e.target.closest ? e.target.closest('a[href*="#corps-"]') : null;
        if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
        var url;
        try { url = new URL(a.href, location.href); } catch (err) { return; }
        if (url.pathname !== location.pathname) return;
        var i = indexForHash(url.hash);
        if (i < 0) return;
        e.preventDefault();
        if (history.pushState) history.pushState(null, '', url.hash);
        goTo(i, true);
      });

      var fromHash = indexForHash(location.hash);
      if (fromHash > -1) {
        select(fromHash);
        root.classList.add('is-in');
        window.addEventListener('load', function () { goTo(fromHash, false); });
      } else if (!reduce.matches && 'IntersectionObserver' in window) {
        root.classList.add('is-armed');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.disconnect();
            root.classList.add('is-in');
            svg.classList.add('is-empty');
            setTimeout(function () { draw(true); }, 640);
          });
        }, { threshold: 0.3 });
        io.observe(stage);
      } else {
        root.classList.add('is-in');
      }

      draw(false);
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () { draw(false); }).observe(stage);
      } else {
        window.addEventListener('resize', function () { draw(false); });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { draw(false); });

      root.gfBmSelectBlock = function (blockId) {
        for (var k = 0; k < tabs.length; k++) { if (tabs[k].getAttribute('data-block-id') === blockId) select(k); }
      };
    }

    document.querySelectorAll('[data-gf-bm]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[data-gf-bm]');
      if (r) init(r);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var r = e.target.closest ? e.target.closest('[data-gf-bm]') : null;
      if (r && r.gfBmSelectBlock) r.gfBmSelectBlock(e.detail.blockId);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var catbar = header.querySelector('[data-catbar]');
    var root = document.documentElement;

    function measure() {
      var full = header.getBoundingClientRect().height;
      var visible = full;
      if (catbar && catbar.classList.contains('is-hidden')) visible -= catbar.offsetHeight;
      var overlayH = 0;
      if (catbar && header.classList.contains('bg-header--overlay')) {
        overlayH = catbar.offsetHeight;
        full -= catbar.offsetHeight;
        if (!catbar.classList.contains('is-hidden')) visible -= catbar.offsetHeight;
      }
      root.style.setProperty('--bg-catbar-overlay', Math.round(overlayH) + 'px');
      root.style.setProperty('--bg-header-space', Math.round(full) + 'px');
      root.style.setProperty('--bg-header-offset', Math.round(visible) + 'px');
    }
    measure();
    window.addEventListener('resize', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

    if (!catbar) return;
    var hideAt = 90;
    var showAt = 40;
    var frame = null;
    function setHidden(hide) {
      if (catbar.classList.contains('is-hidden') === hide) return;
      catbar.classList.toggle('is-hidden', hide);
      measure();
    }
    function apply() {
      frame = null;
      var y = window.scrollY;
      if (y > hideAt) setHidden(true);
      else if (y < showAt) setHidden(false);
    }
    apply();
    window.addEventListener('scroll', function () {
      if (frame === null) frame = requestAnimationFrame(apply);
    }, { passive: true });
  })();

  (function () {
    document.querySelectorAll('[data-gf-need]').forEach(function (need) {
      need.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        need.classList.add('is-dismissed');
        var tile = need.querySelector('.gf-need-tile');
        if (tile && need.contains(document.activeElement)) tile.focus();
      });
      need.addEventListener('mouseleave', function () { need.classList.remove('is-dismissed'); });
      need.addEventListener('focusout', function (event) {
        if (!need.contains(event.relatedTarget)) need.classList.remove('is-dismissed');
      });
    });
  })();

  (function () {
    var wrap = document.querySelector('[data-phone-wrap]');
    var trigger = document.querySelector('[data-phone-trigger]');
    if (!wrap || !trigger) return;
    var closeTimer = null;
    var dismissing = false;

    function open() {
      if (dismissing) return;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      wrap.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      renderStatus();
    }
    function closeNow() {
      closeTimer = null;
      wrap.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }
    function scheduleClose() {
      if (!closeTimer) closeTimer = setTimeout(closeNow, 160);
    }
    wrap.addEventListener('mouseenter', open);
    wrap.addEventListener('mouseleave', scheduleClose);
    wrap.addEventListener('focusin', open);
    wrap.addEventListener('focusout', function (event) {
      if (!wrap.contains(event.relatedTarget)) scheduleClose();
    });
    wrap.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      dismissing = true;
      closeNow();
      trigger.focus();
      dismissing = false;
    });
    document.addEventListener('click', function (event) {
      if (!wrap.contains(event.target)) closeNow();
    });

    var statusEl = wrap.querySelector('[data-phone-status]');
    var statusText = wrap.querySelector('[data-phone-status-text]');
    var rows = wrap.querySelectorAll('[data-phone-hours] .bg-phone-hours-row');
    var lang = (document.documentElement.lang || 'fr').slice(0, 2);

    function schedule() {
      var byDay = {};
      Array.prototype.forEach.call(rows, function (row) {
        var slots = [];
        Array.prototype.forEach.call(row.querySelectorAll('[data-range]'), function (slot) {
          var b = slot.getAttribute('data-range').split('-');
          var labels = slot.textContent.trim().split(/[–—-]/);
          slots.push({ start: +b[0], end: +b[1], startLabel: (labels[0] || '').trim(), endLabel: (labels[1] || '').trim() });
        });
        row.getAttribute('data-phone-days').split(',').forEach(function (d) { byDay[+d] = slots; });
      });
      return byDay;
    }
    function nowInNyon() {
      var names = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      try {
        var bag = {};
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Zurich', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false })
          .formatToParts(new Date()).forEach(function (p) { bag[p.type] = p.value; });
        if (names[bag.weekday] === undefined) return null;
        return { day: names[bag.weekday], minutes: (parseInt(bag.hour, 10) % 24) * 60 + parseInt(bag.minute, 10) };
      } catch (e) { return null; }
    }
    function dayName(day) {
      try { return new Intl.DateTimeFormat(lang, { weekday: 'long', timeZone: 'UTC' }).format(new Date(Date.UTC(2024, 0, 7 + day))); }
      catch (e) { return ''; }
    }
    function fill(tpl, v) { return String(tpl || '').replace('%TIME%', v.time || '').replace('%DAY%', v.day || ''); }
    function renderStatus() {
      if (!statusEl || !statusText || !rows.length) return;
      var byDay = schedule();
      var now = nowInNyon();
      if (!now) return;
      var today = byDay[now.day] || [];
      var openSlot = null, next = null;
      today.forEach(function (s) {
        if (now.minutes >= s.start && now.minutes < s.end) openSlot = s;
        else if (now.minutes < s.start && !next) next = s;
      });
      var label;
      if (openSlot) label = fill(statusEl.getAttribute('data-tpl-open'), { time: openSlot.endLabel });
      else if (next) label = fill(statusEl.getAttribute('data-tpl-today'), { time: next.startLabel });
      else {
        var found = null;
        for (var ahead = 1; ahead <= 7; ahead++) {
          var c = byDay[(now.day + ahead) % 7];
          if (c && c.length) { found = { offset: ahead, slot: c[0] }; break; }
        }
        if (!found) return;
        label = found.offset === 1
          ? fill(statusEl.getAttribute('data-tpl-tomorrow'), { time: found.slot.startLabel })
          : fill(statusEl.getAttribute('data-tpl-day'), { time: found.slot.startLabel, day: dayName((now.day + found.offset) % 7) });
      }
      statusText.textContent = label;
      statusEl.classList.toggle('is-open', !!openSlot);
      statusEl.hidden = false;
    }
    renderStatus();
  })();

  (function () {
    var dlg = document.querySelector('[data-gf-mnav]');
    var openBtn = document.querySelector('[data-gf-menu-open]');
    if (!dlg || !openBtn || typeof dlg.showModal !== 'function') return;
    openBtn.addEventListener('click', function () {
      dlg.showModal();
      openBtn.setAttribute('aria-expanded', 'true');
    });
    dlg.addEventListener('close', function () { openBtn.setAttribute('aria-expanded', 'false'); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-gf-menu-close]') || e.target.closest('a')) dlg.close();
    });
    var wide = window.matchMedia('(min-width: 901px)');
    if (wide.addEventListener) wide.addEventListener('change', function () { if (wide.matches && dlg.open) dlg.close(); });

    var lang = dlg.querySelector('[data-gf-mnav-lang]');
    var langBtn = lang && lang.querySelector('[data-gf-mnav-lang-toggle]');
    var langPanel = lang && lang.querySelector('[data-gf-mnav-lang-panel]');
    if (!lang || !langBtn || !langPanel) return;
    function setLang(open) {
      lang.classList.toggle('is-open', open);
      langBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      langPanel.hidden = !open;
    }
    langBtn.addEventListener('click', function () { setLang(langPanel.hidden); });
    dlg.addEventListener('click', function (e) { if (!langPanel.hidden && !lang.contains(e.target)) setLang(false); });
    dlg.addEventListener('cancel', function (e) {
      if (!langPanel.hidden) { e.preventDefault(); setLang(false); langBtn.focus(); }
    });
    dlg.addEventListener('close', function () { setLang(false); });
  })();

  document.querySelectorAll('form[action$="/localization"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var field = form.querySelector('input[name="return_to"]');
      if (field) field.value = window.location.pathname + window.location.search;
    });
  });

  (function () {
    var dlg = document.querySelector('[data-gf-langm]');
    var openBtn = document.querySelector('[data-gf-langm-open]');
    if (!dlg || !openBtn || typeof dlg.showModal !== 'function') return;
    openBtn.addEventListener('click', function () {
      dlg.showModal();
      openBtn.setAttribute('aria-expanded', 'true');
    });
    dlg.addEventListener('close', function () { openBtn.setAttribute('aria-expanded', 'false'); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-gf-langm-close]')) dlg.close();
    });
    var wide = window.matchMedia('(min-width: 901px)');
    if (wide.addEventListener) wide.addEventListener('change', function () { if (wide.matches && dlg.open) dlg.close(); });
  })();

  (function () {
    document.querySelectorAll('[data-psearch-root]').forEach(function (root) {
      var form = root.querySelector('[data-psearch-form]');
      var input = root.querySelector('[data-psearch-input]');
      var panel = root.querySelector('[data-psearch-panel]');
      var slot = root.querySelector('[data-psearch-slot]');
      var status = root.querySelector('[data-psearch-status]');
      var endpoint = root.dataset.psearchUrl;
      if (!form || !input || !panel || !slot || !endpoint) return;
      var timer = null, controller = null, rendered = '';

      function open() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); }
      function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); }
      function reset() {
        if (controller) controller.abort();
        if (timer) clearTimeout(timer);
        rendered = '';
        slot.innerHTML = '';
        close();
      }
      function links() { return Array.prototype.slice.call(panel.querySelectorAll('[data-psearch-link]')); }
      function request(q) {
        if (controller) controller.abort();
        controller = new AbortController();
        if (status) { status.textContent = status.dataset.loading || ''; status.hidden = false; }
        open();
        var url = endpoint + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search'
          + '&resources[type]=product,article,page&resources[limit]=5&resources[limit_scope]=each'
          + '&resources[options][unavailable_products]=last';
        fetch(url, { signal: controller.signal })
          .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var section = doc.getElementById('shopify-section-predictive-search');
            rendered = section ? section.innerHTML : '';
            slot.innerHTML = rendered;
            if (status) status.hidden = true;
            if (!slot.textContent.trim()) close();
          })
          .catch(function (e) { if (e.name !== 'AbortError') reset(); });
      }
      input.addEventListener('input', function () {
        var q = input.value.trim();
        if (timer) clearTimeout(timer);
        if (q.length < 2) { reset(); return; }
        timer = setTimeout(function () { request(q); }, 220);
      });
      input.addEventListener('focus', function () { if (rendered && input.value.trim().length >= 2) open(); });
      input.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown') return;
        var l = links();
        if (!l.length) return;
        e.preventDefault();
        open();
        l[0].focus();
      });
      panel.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        var l = links();
        var i = l.indexOf(document.activeElement);
        if (i === -1) return;
        e.preventDefault();
        if (e.key === 'ArrowDown') { if (i < l.length - 1) l[i + 1].focus(); }
        else if (i > 0) l[i - 1].focus();
        else input.focus();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) { close(); input.focus(); }
      });
      document.addEventListener('click', function (e) { if (!panel.hidden && !root.contains(e.target)) close(); });
      document.addEventListener('focusin', function (e) { if (!panel.hidden && !root.contains(e.target)) close(); });
      form.addEventListener('submit', close);
    });
  })();

  (function () {
    var langWrap = document.querySelector('[data-lang]');
    var langToggle = document.querySelector('[data-lang-toggle]');
    var langPanel = document.querySelector('[data-lang-panel]');
    if (!langWrap || !langToggle || !langPanel) return;
    function closeLang() {
      langWrap.classList.remove('is-open');
      langToggle.setAttribute('aria-expanded', 'false');
      langPanel.hidden = true;
    }
    langToggle.addEventListener('click', function () {
      var open = langWrap.classList.toggle('is-open');
      langToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      langPanel.hidden = !open;
    });
    document.addEventListener('click', function (event) { if (!langWrap.contains(event.target)) closeLang(); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && langWrap.classList.contains('is-open')) { closeLang(); langToggle.focus(); }
    });
  })();

  (function () {
    var header = document.querySelector('[data-header]');
    if (!header || !header.classList.contains('bg-header--overlay') || !document.body.classList.contains('gf-t-index')) return;
    var row = header.querySelector('.gf-needs-row');
    var catbar = header.querySelector('[data-catbar]');
    if (!row || !row.children.length) return;
    var phone = window.matchMedia('(max-width: 900px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var SPEED = 16;
    var RESUME_MS = 4000;
    var originals = Array.prototype.slice.call(row.children);
    var clones = [];
    var pos = 0, last = 0, frame = null, resumeTimer = null, held = false, setWidth = 0;

    function addClones() {
      originals.forEach(function (li) {
        var c = li.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
        c.querySelectorAll('a, button').forEach(function (el) { el.setAttribute('tabindex', '-1'); el.removeAttribute('aria-describedby'); });
        row.appendChild(c);
        clones.push(c);
      });
    }
    function measure() { setWidth = clones.length ? clones[0].offsetLeft - originals[0].offsetLeft : 0; }
    function tick(t) {
      frame = requestAnimationFrame(tick);
      var dt = last ? Math.min(t - last, 100) / 1000 : 0;
      last = t;
      if (held || !setWidth || document.hidden || (catbar && catbar.classList.contains('is-hidden'))) return;
      pos += SPEED * dt;
      if (pos >= setWidth) pos -= setWidth;
      row.scrollLeft = pos;
    }
    function hold() { held = true; clearTimeout(resumeTimer); }
    function release() {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        pos = row.scrollLeft;
        if (setWidth && pos >= setWidth) pos -= setWidth;
        held = false;
      }, RESUME_MS);
    }
    function start() {
      if (frame || !phone.matches || reduce.matches) return;
      addClones();
      row.style.scrollSnapType = 'none';
      measure();
      pos = row.scrollLeft; last = 0; held = false;
      frame = requestAnimationFrame(tick);
    }
    function stop() {
      if (!frame) return;
      cancelAnimationFrame(frame); frame = null;
      clearTimeout(resumeTimer);
      clones.forEach(function (c) { c.remove(); }); clones = [];
      row.style.scrollSnapType = '';
      row.scrollLeft = 0;
    }
    function sync() { if (phone.matches && !reduce.matches) start(); else stop(); }

    ['pointerdown', 'touchstart', 'wheel'].forEach(function (type) { row.addEventListener(type, hold, { passive: true }); });
    ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (type) { row.addEventListener(type, release, { passive: true }); });
    row.addEventListener('wheel', release, { passive: true });
    row.addEventListener('focusin', hold);
    row.addEventListener('focusout', release);
    window.addEventListener('resize', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    if (phone.addEventListener) { phone.addEventListener('change', sync); reduce.addEventListener('change', sync); }
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notre-histoire"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-about]');
    if (!root) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timeline = root.querySelector('[data-tl]');
    var track = root.querySelector('[data-tl-track]');
    var fill = root.querySelector('[data-tl-fill]');
    var prev = root.querySelector('[data-tl-prev]');
    var next = root.querySelector('[data-tl-next]');
    if (!timeline || !track) return;
    var frame = null;

    function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }

    function paint() {
      frame = null;
      var max = maxScroll();
      if (fill) {
        var progress = max <= 1 ? 1 : track.scrollLeft / max;
        timeline.style.setProperty('--ab-tl-progress', progress.toFixed(4));
      }
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    }

    function schedule() { if (frame === null) frame = requestAnimationFrame(paint); }

    function step(dir) {
      var first = track.querySelector('.ab-tl-stop');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var distance = first ? first.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * distance, behavior: reduced ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    paint();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-faq]');
    if (!root) return;
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-faq-link]'));
    var list = root.querySelector('[data-faq-nav]');
    if (!links.length) return;
    var byId = {};
    links.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
    var current = null;
    function set(id) {
      var a = byId[id];
      if (!a || a === current) return;
      if (current) current.removeAttribute('aria-current');
      a.setAttribute('aria-current', 'true');
      current = a;
      if (list && list.scrollWidth > list.clientWidth + 4) {
        var left = a.offsetLeft - list.offsetLeft - (list.clientWidth - a.offsetWidth) / 2;
        list.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }
    links.forEach(function (a) { a.addEventListener('click', function () { set(a.getAttribute('href').slice(1)); }); });
    set(links[0].getAttribute('href').slice(1));
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var h = e.target.querySelector('h2');
        if (e.isIntersecting && h) set(h.id);
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    root.querySelectorAll('[data-faq-group]').forEach(function (g) { io.observe(g); });
    var head = root.querySelector('.gf-faq-head');
    if (head) new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) set(links[0].getAttribute('href').slice(1));
    }).observe(head);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"]) return;
  try {
    
  (function () {
    function initShop() {
      var root = document.querySelector('[data-shop]');
      if (!root || root.hasAttribute('data-shop-ready')) return;
      root.setAttribute('data-shop-ready', '');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-shop-item]'));
      var countEl = root.querySelector('[data-shop-count]');
      var labelEl = root.querySelector('[data-shop-need-label]');
      var resetEl = root.querySelector('[data-shop-reset]');
      var emptyEl = root.querySelector('[data-shop-empty]');
      var names = {};
      try { names = JSON.parse(root.querySelector('[data-shop-needs]').textContent); } catch (e) {}
      function apply(slug) {
        var shown = 0;
        items.forEach(function (el) {
          var needs = ' ' + (el.getAttribute('data-needs') || '') + ' ';
          var on = !slug || needs.indexOf(' ' + slug + ' ') !== -1;
          el.hidden = !on;
          if (on && el.tagName === 'ARTICLE') shown++;
        });
        if (countEl) {
          var tpl = countEl.getAttribute(shown === 1 ? 'data-one' : 'data-other') || '';
          countEl.textContent = tpl.replace(/\d+/, shown);
        }
        if (labelEl) labelEl.textContent = slug ? names[slug] : labelEl.getAttribute('data-all');
        if (resetEl) resetEl.hidden = !slug;
        if (emptyEl) emptyEl.hidden = shown > 0;
        document.querySelectorAll('[data-gf-need][data-need-slug]').forEach(function (need) {
          var on = !!slug && need.getAttribute('data-need-slug') === slug;
          need.classList.toggle('is-current', on);
          var tile = need.querySelector('.gf-need-tile');
          if (tile) { if (on) tile.setAttribute('aria-current', 'true'); else tile.removeAttribute('aria-current'); }
        });
      }
      function fromHash() {
        var slug = decodeURIComponent((location.hash || '').replace(/^#/, ''));
        if (slug && !names[slug]) return;
        apply(slug);
      }
      if (resetEl) resetEl.addEventListener('click', function (e) {
        e.preventDefault();
        try { history.replaceState(null, '', location.pathname + location.search); } catch (err) {}
        apply('');
      });
      window.addEventListener('hashchange', fromHash);
      fromHash();

      requestAnimationFrame(function () { root.classList.add('is-ready'); });

      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      root.classList.add('is-armed');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.15 });
      root.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initShop);
    else initShop();
    document.addEventListener('shopify:section:load', initShop);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    function initPdp() {
      var pdp = document.querySelector('[data-pdp]');
      if (!pdp || pdp.hasAttribute('data-pdp-ready')) return;
      pdp.setAttribute('data-pdp-ready', '');

      var sample = pdp.getAttribute('data-money-sample') || '1,234.56';
      var mp = sample.match(/^(.*?)(\d[\d.,'’   ]*\d)(.*)$/) || [null, '', '1,234.56', ''];
      var moneyPre = mp[1], moneyNum = mp[2], moneyPost = mp[3];
      var decSep = moneyNum.charAt(moneyNum.length - 3);
      var thouSep = moneyNum.length > 6 ? moneyNum.charAt(1) : '';
      function fmt(cents) {
        var parts = (Math.abs(cents || 0) / 100).toFixed(2).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
        return moneyPre + parts[0] + decSep + parts[1] + moneyPost;
      }

      var VARIANTS = {};
      var variantsEl = pdp.querySelector('[data-pdp-variants]');
      try { VARIANTS = variantsEl ? JSON.parse(variantsEl.textContent) : {}; } catch (e) { VARIANTS = {}; }

      var form = pdp.querySelector('[data-pdp-form]') || pdp.querySelector('form[action*="/cart/add"]');
      var qtyInput = pdp.querySelector('[data-pdp-qty]');
      var addBtn = pdp.querySelector('[data-pdp-add]');
      var stockLine = pdp.querySelector('[data-pdp-stockline]');
      var priceEl = pdp.querySelector('[data-pdp-price]');
      var wasEl = pdp.querySelector('[data-pdp-was]');
      var wasAmount = pdp.querySelector('[data-pdp-was-amount]');
      var sticky = pdp.querySelector('[data-pdp-sticky]');
      var stickyPrice = pdp.querySelector('[data-pdp-sticky-price]');
      var stickyBtn = pdp.querySelector('[data-pdp-stickybuy]');

      var TIERS = [];
      try {
        var tiersEl = pdp.querySelector('[data-pdp-tiers]');
        var parsedTiers = tiersEl ? JSON.parse(tiersEl.textContent) : [];
        if (Array.isArray(parsedTiers)) {
          TIERS = parsedTiers.filter(function (t) { return t && isFinite(t.min_quantity) && isFinite(t.amount_off_cents) && t.amount_off_cents > 0; });
        }
      } catch (e) { TIERS = []; }
      TIERS.sort(function (a, b) { return b.min_quantity - a.min_quantity; });

      function unitFor(v, qty) {
        if (!v) return 0;
        for (var i = 0; i < TIERS.length; i++) {
          if (qty < TIERS[i].min_quantity) continue;
          var unit = v.price - TIERS[i].amount_off_cents;
          if (unit > 0 && unit < v.price) return unit;
        }
        return v.price;
      }
      function refFor(v) { return v ? (v.compareAtPrice || v.price) : 0; }

      var variantIdEl = form ? form.querySelector('input[name="id"]:checked, input[type="hidden"][name="id"]') : null;
      var currentId = variantIdEl ? variantIdEl.value : null;
      function currentVariant() { return VARIANTS[currentId] || null; }

      var qtySet = pdp.querySelector('[data-pdp-qtyset]');
      var qtyOpts = qtySet ? Array.prototype.slice.call(qtySet.querySelectorAll('[data-pdp-qtyopt]')) : [];
      var qtyRows = qtySet ? Array.prototype.slice.call(qtySet.querySelectorAll('[data-pdp-qtyrow]')) : [];
      var customRow = qtySet ? qtySet.querySelector('[data-pdp-qtycustom]') : null;
      var customOpt = customRow ? customRow.querySelector('[data-pdp-qtyopt]') : null;
      var trigger = qtySet ? qtySet.querySelector('[data-pdp-qtytrigger]') : null;
      var saveLabel = qtySet ? qtySet.getAttribute('data-save-label') || '' : '';
      var pctTpl = qtySet ? qtySet.getAttribute('data-pct') || '-__N__%' : '';
      var shipFree = qtySet ? parseInt(qtySet.getAttribute('data-ship-free'), 10) || 0 : 0;

      function clampQty(v, min) {
        var n = parseInt(v, 10);
        if (!isFinite(n) || n < min) n = min;
        if (n > 99) n = 99;
        return n;
      }
      function rowQty(row) {
        var opt = row.querySelector('[data-pdp-qtyopt]');
        return opt ? parseInt(opt.value, 10) || 1 : 1;
      }
      function selectedQty() {
        if (!qtySet) return qtyInput ? clampQty(qtyInput.value, 1) : 1;
        for (var i = 0; i < qtyOpts.length; i++) if (qtyOpts[i].checked) return parseInt(qtyOpts[i].value, 10) || 1;
        return 1;
      }

      function renderRows() {
        var v = currentVariant();
        if (!v) return;
        var ref = v.price;
        qtyRows.forEach(function (row) {
          var qty = rowQty(row);
          var unit = unitFor(v, qty);
          var total = unit * qty;
          var saving = (ref - unit) * qty;
          var pct = unit < ref ? Math.round((1 - unit / ref) * 100) : 0;
          var totalEl = row.querySelector('[data-qty-total]');
          var badge = row.querySelector('[data-qty-badge]');
          var save = row.querySelector('[data-qty-save]');
          var ship = row.querySelector('[data-qty-ship]');
          var was = row.querySelector('[data-qty-was]');
          var wasAmt = row.querySelector('[data-qty-was-amount]');
          if (totalEl) totalEl.textContent = fmt(total);
          if (badge) { badge.hidden = pct <= 0; badge.textContent = pct > 0 ? pctTpl.replace('__N__', pct) : ''; }
          if (save) { save.hidden = saving <= 0; save.textContent = saving > 0 ? saveLabel.replace('__AMOUNT__', fmt(saving)) : ''; }
          if (ship) ship.hidden = true;
          if (was) { was.hidden = saving <= 0; if (wasAmt) wasAmt.textContent = fmt(ref * qty); }
        });
      }

      function renderPrice() {
        var v = currentVariant();
        if (!v) return;
        var qty = selectedQty();
        var unit = unitFor(v, qty);
        var ref = refFor(v);
        if (priceEl) priceEl.textContent = fmt(unit);
        if (wasEl) {
          wasEl.hidden = !(ref > unit);
          if (wasAmount && ref > unit) wasAmount.textContent = fmt(ref);
        }
        if (stickyPrice) stickyPrice.textContent = qty > 1 ? qty + ' × ' + fmt(unit) : fmt(unit);
        [addBtn, stickyBtn].forEach(function (b) { if (b) b.disabled = !v.available; });
        if (stockLine) stockLine.hidden = !v.available;
      }

      qtyOpts.forEach(function (opt) {
        opt.addEventListener('change', function () {
          if (opt !== customOpt && customRow && !customRow.hidden) {
            customRow.hidden = true;
            if (trigger) trigger.hidden = false;
          }
          renderPrice();
        });
      });

      if (trigger && customRow && customOpt) {
        trigger.hidden = false;
        var customInput = customRow.querySelector('[data-pdp-qty]');
        var setCustom = function (n) {
          var q = clampQty(n, 4);
          if (customInput) customInput.value = q;
          customOpt.value = q;
          customOpt.checked = true;
          renderRows();
          renderPrice();
        };
        trigger.addEventListener('click', function () {
          trigger.hidden = true;
          customRow.hidden = false;
          setCustom(customInput ? customInput.value : 4);
          if (customInput) customInput.focus();
        });
        customRow.querySelectorAll('[data-pdp-step]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            setCustom(clampQty(customInput.value, 4) + (parseInt(btn.getAttribute('data-pdp-step'), 10) || 0));
          });
        });
        if (customInput) {
          customInput.addEventListener('input', function () {
            var n = parseInt(customInput.value, 10);
            if (isFinite(n) && n >= 4 && n <= 99) setCustom(n);
          });
          customInput.addEventListener('change', function () { setCustom(customInput.value); });
        }
      }

      if (!qtySet && qtyInput) {
        pdp.querySelectorAll('[data-pdp-step]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            qtyInput.value = clampQty(clampQty(qtyInput.value, 1) + (parseInt(btn.getAttribute('data-pdp-step'), 10) || 0), 1);
          });
        });
        qtyInput.addEventListener('change', function () { qtyInput.value = clampQty(qtyInput.value, 1); });
      }

      pdp.querySelectorAll('[data-pdp-variant]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!VARIANTS[radio.value]) return;
          currentId = radio.value;
          renderRows();
          renderPrice();
        });
      });

      if (qtySet) { renderRows(); renderPrice(); }

      var track = pdp.querySelector('[data-pdp-track]');
      var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-pdp-slide]')) : [];
      var thumbs = Array.prototype.slice.call(pdp.querySelectorAll('[data-pdp-thumb]'));
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var active = 0;
      thumbs.forEach(function (t, i) { if (t.classList.contains('is-active')) active = i; });

      function markActive(i) {
        active = i;
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-active', n === i);
          if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
      }
      function scrollToImage(i, smooth) {
        if (!track) return;
        var left = track.clientWidth * i;
        if (smooth && !reduceMotion.matches && track.scrollTo) track.scrollTo({ left: left, behavior: 'smooth' });
        else track.scrollLeft = left;
      }
      function showImage(i, smooth) {
        if (!slides.length) return;
        i = ((i % slides.length) + slides.length) % slides.length;
        markActive(i);
        scrollToImage(i, smooth !== false);
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showImage(i); }); });

      if (track) {
        scrollToImage(active, false);
        var queued = false;
        track.addEventListener('scroll', function () {
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () {
            queued = false;
            var w = track.clientWidth;
            if (!w) return;
            var i = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
            if (i !== active) markActive(i);
          });
        }, { passive: true });
        track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); showImage(active + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); showImage(active - 1); }
        });
        var resizeTimer = null;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () { scrollToImage(active, false); }, 150);
        });
      }

      var opener = pdp.querySelector('[data-pdp-zoom-open]');
      var zoom = pdp.querySelector('[data-pdp-zoom]');
      if (opener && zoom) {
        var zoomImg = zoom.querySelector('[data-pdp-zoom-img]');
        var zoomCount = zoom.querySelector('[data-pdp-zoom-count]');
        var zoomButtons = Array.prototype.slice.call(zoom.querySelectorAll('button'));
        var returnFocus = null;
        var downOnBackdrop = false;
        var render = function () {
          var slide = slides[active];
          if (!slide) return;
          var img = slide.querySelector('img');
          zoomImg.alt = img ? img.alt : '';
          zoomImg.width = parseInt(slide.getAttribute('data-zoom-w'), 10) || 1000;
          zoomImg.height = parseInt(slide.getAttribute('data-zoom-h'), 10) || 1000;
          var srcset = slide.getAttribute('data-zoom-srcset');
          if (srcset) zoomImg.srcset = srcset;
          zoomImg.src = slide.getAttribute('data-zoom-src') || (img ? img.currentSrc || img.src : '');
          if (zoomCount) zoomCount.textContent = (active + 1) + ' / ' + slides.length;
        };
        var isOpen = function () { return !zoom.hasAttribute('hidden'); };
        var open = function () {
          returnFocus = document.activeElement;
          render();
          zoom.removeAttribute('hidden');
          document.body.classList.add('bg-pdp-zoom-lock');
          var c = zoom.querySelector('[data-pdp-zoom-close]');
          if (c) c.focus();
        };
        var close = function () {
          if (!isOpen()) return;
          zoom.setAttribute('hidden', '');
          document.body.classList.remove('bg-pdp-zoom-lock');
          if (returnFocus && returnFocus.focus) returnFocus.focus();
        };
        var step = function (d) { showImage(active + d, false); render(); };
        opener.addEventListener('click', open);
        zoom.addEventListener('mousedown', function (e) { downOnBackdrop = !e.target.closest('.bg-pdp-zoom-img, button'); });
        zoom.addEventListener('click', function (e) {
          if (e.target.closest('.bg-pdp-zoom-img, button')) return;
          if (downOnBackdrop) close();
        });
        zoom.querySelector('[data-pdp-zoom-close]').addEventListener('click', close);
        zoom.querySelectorAll('[data-pdp-zoom-step]').forEach(function (b) {
          b.addEventListener('click', function () { step(parseInt(b.getAttribute('data-pdp-zoom-step'), 10) || 1); });
        });
        document.addEventListener('keydown', function (e) {
          if (!isOpen()) return;
          if (e.key === 'Escape') { e.preventDefault(); close(); return; }
          if (e.key === 'ArrowRight') { e.preventDefault(); step(1); return; }
          if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); return; }
          if (e.key !== 'Tab') return;
          var i = zoomButtons.indexOf(document.activeElement);
          var t = e.shiftKey ? i - 1 : i + 1;
          if (i !== -1 && t >= 0 && t < zoomButtons.length) return;
          e.preventDefault();
          zoomButtons[e.shiftKey ? zoomButtons.length - 1 : 0].focus();
        });
      }

      if (sticky && addBtn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var gone = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', gone);
            sticky.setAttribute('aria-hidden', gone ? 'false' : 'true');
            if (stickyBtn) stickyBtn.tabIndex = gone ? 0 : -1;
          });
        });
        io.observe(addBtn);
        if (stickyBtn) {
          stickyBtn.addEventListener('click', function () {
            if (form && form.requestSubmit) form.requestSubmit(addBtn);
            else addBtn.click();
          });
        }
      }

      var tabsRoot = pdp.querySelector('[data-pdp-tabs]');
      if (tabsRoot) {
        var tabs = Array.prototype.slice.call(tabsRoot.querySelectorAll('[data-pdp-tab]'));
        var panels = Array.prototype.slice.call(tabsRoot.querySelectorAll('[data-pdp-panel]'));
        var tablist = tabsRoot.querySelector('[data-pdp-tablist]');
        var wide = window.matchMedia('(min-width: 901px)');
        var current = panels[0] ? panels[0].id : '';
        var openSet = {};
        if (current && wide.matches) openSet[current] = true;

        var panelOf = function (id) { for (var i = 0; i < panels.length; i++) if (panels[i].id === id) return panels[i]; return null; };
        var bodyOf = function (p) { return p.querySelector('.bg-pdp-panel-body'); };
        var toggleOf = function (p) { return p.querySelector('[data-pdp-toggle]'); };

        var apply = function () {
          var isTabs = wide.matches && tabs.length > 1;
          tabsRoot.classList.toggle('is-tabs', isTabs);
          tabsRoot.classList.toggle('is-acc', !isTabs);
          panels.forEach(function (p) {
            var body = bodyOf(p), tg = toggleOf(p);
            if (isTabs) {
              var on = p.id === current;
              p.hidden = !on;
              p.setAttribute('role', 'tabpanel');
              p.setAttribute('aria-labelledby', 'bg-pdp-tab-' + p.id);
              p.setAttribute('tabindex', '-1');
              if (body) body.hidden = false;
              if (tg) tg.setAttribute('tabindex', '-1');
            } else {
              var open = !!openSet[p.id];
              p.hidden = false;
              p.removeAttribute('role');
              p.removeAttribute('aria-labelledby');
              p.removeAttribute('tabindex');
              if (body) body.hidden = !open;
              if (tg) { tg.removeAttribute('tabindex'); tg.setAttribute('aria-expanded', open ? 'true' : 'false'); }
            }
          });
          if (tablist) tablist.hidden = !isTabs;
          tabs.forEach(function (t) {
            var on = t.getAttribute('data-pdp-tab') === current;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.tabIndex = on ? 0 : -1;
          });
        };
        var select = function (id, focusTab) {
          if (!panelOf(id)) return;
          current = id;
          openSet[id] = true;
          apply();
          if (focusTab) { var t = tabsRoot.querySelector('[data-pdp-tab="' + id + '"]'); if (t) t.focus(); }
        };

        tabs.forEach(function (t, i) {
          t.addEventListener('click', function () { select(t.getAttribute('data-pdp-tab')); });
          t.addEventListener('keydown', function (e) {
            var n = -1;
            if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
            else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
            else if (e.key === 'Home') n = 0;
            else if (e.key === 'End') n = tabs.length - 1;
            if (n < 0) return;
            e.preventDefault();
            select(tabs[n].getAttribute('data-pdp-tab'), true);
          });
        });
        panels.forEach(function (p) {
          var tg = toggleOf(p);
          if (!tg) return;
          tg.addEventListener('click', function () {
            if (tabsRoot.classList.contains('is-tabs')) return;
            openSet[p.id] = !openSet[p.id];
            if (openSet[p.id]) current = p.id;
            apply();
          });
        });

        var reveal = function (hash, smooth) {
          var id = decodeURIComponent((hash || '').replace(/^#/, ''));
          if (!id) return false;
          var target = document.getElementById(id);
          if (!target || !tabsRoot.contains(target)) return false;
          var panel = target.closest('[data-pdp-panel]');
          if (!panel) return false;
          select(panel.id);
          var dest = (target === panel && tabsRoot.classList.contains('is-tabs')) ? tabsRoot : target;
          requestAnimationFrame(function () {
            dest.scrollIntoView({ behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto', block: 'start' });
          });
          return true;
        };
        pdp.addEventListener('click', function (e) {
          var a = e.target.closest('a[href^="#"]');
          if (!a) return;
          if (reveal(a.getAttribute('href'), true)) {
            e.preventDefault();
            try { history.replaceState(null, '', a.getAttribute('href')); } catch (err) {}
          }
        });
        window.addEventListener('hashchange', function () { reveal(location.hash, true); });

        if (wide.addEventListener) wide.addEventListener('change', apply); else if (wide.addListener) wide.addListener(apply);
        apply();
        if (location.hash) reveal(location.hash, false);
      }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPdp);
    else initPdp();
    document.addEventListener('shopify:section:load', initPdp);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    var input = document.querySelector('[data-srch-input]');
    var box = document.querySelector('[data-srch-suggest]');
    var status = document.querySelector('[data-srch-status]');
    if (!input || !box) return;
    var url = input.getAttribute('data-suggest-url');
    var timer = null;
    var last = '';
    var ctrl = null;

    function hide() {
      box.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function run() {
      var q = input.value.trim();
      if (q.length < 2) { hide(); last = ''; return; }
      if (q === last) return;
      last = q;
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      fetch(url + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,article,page&resources[limit]=6&resources[options][prefix]=last',
        ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sec = doc.getElementById('shopify-section-predictive-search');
          var markup = sec ? sec.innerHTML.trim() : '';
          if (!markup || input.value.trim() !== q) return;
          box.innerHTML = markup;
          box.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          var said = box.querySelector('[data-psearch-count]');
          if (status) status.textContent = said ? said.textContent : '';
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(run, 220);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hide(); return; }
      if (e.key === 'ArrowDown' && !box.hidden) {
        var first = box.querySelector('a');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });
    box.addEventListener('keydown', function (e) {
      var links = Array.prototype.slice.call(box.querySelectorAll('a'));
      var i = links.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i > -1 && i < links.length - 1) { e.preventDefault(); links[i + 1].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (i > 0) links[i - 1].focus(); else input.focus(); }
      else if (e.key === 'Escape') { hide(); input.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-srch-form]')) hide();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temoignages"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-tm-root]');
    if (!root) return;
    var PAGE = 12;
    var filter = root.querySelector('[data-tm-filter]');
    var bar = root.querySelector('[data-tm-bar] .gf-tm-bar-inner');
    var status = root.querySelector('[data-tm-status]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-tm-item]'));
    var prods = Array.prototype.slice.call(root.querySelectorAll('[data-tm-prod]'));
    var pager = root.querySelector('[data-tm-pager]');
    var progress = root.querySelector('[data-tm-progress]');
    var more = root.querySelector('[data-tm-more]');
    var txtMore = root.getAttribute('data-read-more');
    var txtLess = root.getAttribute('data-read-less');
    var state = { handle: 'all', limit: PAGE };
    var chips = [];
    var uid = 0;

    function clamp(li) {
      if (li.hidden || li.hasAttribute('data-tm-measured')) return;
      var q = li.querySelector('[data-tm-quote]');
      var btn = li.querySelector('[data-tm-read]');
      if (!q || !btn) return;
      q.classList.add('is-clamped');
      if (q.scrollHeight - q.clientHeight > 6) {
        if (!q.id) q.id = 'gf-tm-q-' + (++uid);
        btn.setAttribute('aria-controls', q.id);
        btn.hidden = false;
      } else {
        q.classList.remove('is-clamped');
        btn.hidden = true;
      }
      li.setAttribute('data-tm-measured', '');
    }

    function render(announce, focusIndex) {
      var match = items.filter(function (li) { return state.handle === 'all' || li.getAttribute('data-p') === state.handle; });
      items.forEach(function (li) { li.hidden = true; });
      match.forEach(function (li, i) { li.hidden = i >= state.limit; });
      prods.forEach(function (p) { p.hidden = p.getAttribute('data-tm-prod') !== state.handle; });
      root.setAttribute('data-tm-view', state.handle === 'all' ? 'all' : 'one');
      var shown = Math.min(state.limit, match.length);
      if (pager) {
        pager.hidden = false;
        if (progress) progress.textContent = (progress.getAttribute('data-tpl') || '').replace('__S__', shown).replace('__T__', match.length);
        if (more) more.hidden = shown >= match.length;
      }
      items.forEach(clamp);
      if (announce && status) {
        var chip = filter && filter.querySelector('[aria-pressed="true"]');
        var label = chip ? chip.firstChild.textContent.trim() + ' : ' : '';
        status.textContent = label + (progress ? progress.textContent : '');
      }
      if (focusIndex != null && match[focusIndex]) {
        match[focusIndex].setAttribute('tabindex', '-1');
        match[focusIndex].focus({ preventScroll: true });
      }
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tm-read]');
      if (!btn) return;
      var q = btn.closest('.gf-tm-card').querySelector('[data-tm-quote]');
      var open = btn.getAttribute('aria-expanded') !== 'true';
      q.classList.toggle('is-clamped', !open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? txtLess : txtMore;
      if (!open) {
        var card = btn.closest('.gf-tm-card');
        var top = card.getBoundingClientRect().top;
        var offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--bg-header-offset')) || 120;
        if (top < offset) window.scrollBy({ top: top - offset - (bar ? bar.offsetHeight : 0) - 16 });
      }
    });

    if (more) more.addEventListener('click', function () {
      var from = state.limit;
      state.limit += PAGE;
      render(true, from);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        items.forEach(function (li) {
          var btn = li.querySelector('[data-tm-read]');
          if (btn && btn.getAttribute('aria-expanded') === 'true') return;
          li.removeAttribute('data-tm-measured');
        });
        items.forEach(clamp);
      }, 200);
    });

    function apply(handle, fromUser) {
      state.handle = handle;
      state.limit = PAGE;
      chips.forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-tm-show') === handle ? 'true' : 'false'); });
      render(fromUser);
      if (fromUser) {
        try { history.replaceState(null, '', handle === 'all' ? location.pathname + location.search : '#' + handle); } catch (e) {}
        var top = root.querySelector('[data-tm-body]').getBoundingClientRect().top;
        var offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--bg-header-offset')) || 120;
        if (top < offset + (bar ? bar.offsetHeight : 0)) window.scrollBy({ top: top - offset - (bar ? bar.offsetHeight : 0) - 10, behavior: 'auto' });
      }
    }

    if (filter && bar) {
      bar.insertBefore(filter, bar.firstChild);
      filter.hidden = false;
      chips = Array.prototype.slice.call(filter.querySelectorAll('[data-tm-show]'));
      chips.forEach(function (c) {
        c.addEventListener('click', function () { apply(c.getAttribute('data-tm-show'), true); });
      });
    }
    function fromHash() {
      var h = decodeURIComponent((location.hash || '').slice(1));
      if (h && prods.some(function (p) { return p.getAttribute('data-tm-prod') === h; })) { apply(h, false); return true; }
      return false;
    }
    if (!fromHash()) render(false);
    window.addEventListener('hashchange', fromHash);
  })();

  } catch(e) { console.error(e); }
})();
})();
